(function () {
    'use strict';

    angular.module('app.consulting', ['angular.filter', 'ui.calendar']);
})();